import Container from "../../Components/Container";
import ProductCard from "../../Components/ProductCard";
import { Link, useNavigate } from "react-router-dom";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { Switch } from "@headlessui/react";
import toast, { Toaster } from "react-hot-toast";
import { BarcodeScanner, useTorch } from "react-barcode-scanner";
import {
  FaCamera,
  FaFilter,
  FaSearch,
  FaBarcode,
  FaTimes,
  FaTrash,
  FaBox,
  FaPlus,
  FaBolt,
  FaSpinner,
} from "react-icons/fa";
import MultiRangeSlider from "multi-range-slider-react";

const SLIDER_MAX = 50000;

const inputBase =
  "w-full rounded-xl border border-slate-200 bg-slate-50/80 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20";

const labelBase = "mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500";

const Product = () => {
  const [items, setItems] = useState([]);
  const [deletedItems, setDeletedItems] = useState([]);
  const [deleteItem, setDeleteItem] = useState(false);
  const [barcode, setBarcode] = useState("");
  const [name, setName] = useState("");
  const [isSupportTorch, , onTorchSwitch] = useTorch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [allowPaginate, setAllowPaginate] = useState(true);
  const [listVersion, setListVersion] = useState(0);
  const observer = useRef();
  const navigate = useNavigate();
  const filterContainer = useRef();
  const [minValue, set_minValue] = useState(1);
  const [maxValue, set_maxValue] = useState(SLIDER_MAX);
  const [category, setCategory] = useState("");
  const [stockStatus, setStockStatus] = useState("all");
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [categories, setCategories] = useState([]);

  const handleInput = (e) => {
    set_minValue(e.minValue);
    set_maxValue(e.maxValue);
  };

  const fetchPaginatedPage = useCallback((pageNum, mode) => {
    const formdata = new FormData();
    formdata.append("action", "selectWithPage");
    formdata.append("page", String(pageNum));
    setLoading(true);
    fetch(process.env.REACT_APP_BASE_URL + "product.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        setItems((prev) =>
          mode === "append" ? [...prev, ...data] : data
        );
      })
      .catch(() => toast.error("Ürünler yüklenirken bir hata oluştu"))
      .finally(() => setLoading(false));
  }, []);

  const lastCardElementRef = useCallback(
    (node) => {
      if (loading || deleteItem || !allowPaginate) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setPage((prevPage) => prevPage + 1);
          }
        },
        { rootMargin: "120px" }
      );
      if (node) observer.current.observe(node);
    },
    [loading, deleteItem, allowPaginate]
  );

  useEffect(() => {
    window.localStorage.setItem("count", 1);

    const formdata = new FormData();
    formdata.append("action", "select");
    fetch(process.env.REACT_APP_BASE_URL + "categories.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => setCategories(data))
      .catch(() => toast.error("Kategoriler yüklenirken bir hata oluştu"));

    const formDeleted = new FormData();
    formDeleted.append("action", "selectDeleted");
    fetch(process.env.REACT_APP_BASE_URL + "product.php", {
      method: "POST",
      body: formDeleted,
    })
      .then((res) => res.json())
      .then((data) => setDeletedItems(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (deleteItem || !allowPaginate) return;
    fetchPaginatedPage(page, page > 1 ? "append" : "replace");
  }, [page, deleteItem, allowPaginate, listVersion, fetchPaginatedPage]);

  const linkHandel = () => {
    window.localStorage.setItem("count", 30);
    navigate("/dashboard/addProduct");
  };

  const options = {
    formats: [
      "ean_13",
      "code_128",
      "code_39",
      "code_93",
      "codabar",
      "ean_8",
      "itf",
      "qr_code",
      "upc_a",
      "upc_e",
    ],
  };

  const onCapture = (detected) => {
    if (!detected) return;
    const formdata = new FormData();
    formdata.append("action", "findByBarcode");
    formdata.append("barcode", detected.rawValue);
    fetch(process.env.REACT_APP_BASE_URL + "product.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== 404) {
          setAllowPaginate(false);
          setPage(1);
          setItems([data.data]);
          setOpen(false);
        } else {
          toast.error("Ürün bulunamadı");
        }
      })
      .catch(() => toast.error("Barkod aranırken bir hata oluştu"));
  };

  const filterByname = () => {
    const formdata = new FormData();
    formdata.append("action", "findByName");
    formdata.append("name", name.trim() === "" ? "a" : name.trim());
    formdata.append("min", minValue);
    formdata.append("max", maxValue);
    formdata.append("category", category);
    formdata.append("stockStatus", stockStatus);
    formdata.append("sortBy", sortBy);
    formdata.append("sortOrder", sortOrder);
    formdata.append("startDate", startDate);
    formdata.append("endDate", endDate);
    fetch(process.env.REACT_APP_BASE_URL + "product.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== 200) {
          toast.error(data.message);
        } else {
          setAllowPaginate(false);
          setPage(1);
          setItems(data.data);
          filterHandel();
        }
      })
      .catch(() => toast.error("Filtre uygulanırken bir hata oluştu"));
  };

  const deleteAll = () => {
    const formdata = new FormData();
    formdata.append("action", "deletePermaAll");
    fetch(process.env.REACT_APP_BASE_URL + "product.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== 200) {
          toast.error(data.message);
        } else {
          toast.success(data.message);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      })
      .catch((e) => console.error(e));
  };

  const filterHandel = () => {
    filterContainer.current.classList.toggle("hidden");
  };

  const keyHandel = (e) => {
    if (e.key !== "Enter" || !barcode.trim()) return;
    const formdata = new FormData();
    formdata.append("action", "findByBarcode");
    formdata.append("barcode", barcode.trim());
    fetch(process.env.REACT_APP_BASE_URL + "product.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== 404) {
          setAllowPaginate(false);
          setPage(1);
          setItems([data.data]);
        } else {
          toast.error(data.message);
        }
      })
      .catch(() => toast.error("Barkod aranırken bir hata oluştu"));
  };

  const resetFilters = () => {
    setName("");
    set_minValue(1);
    set_maxValue(SLIDER_MAX);
    setCategory("");
    setStockStatus("all");
    setSortBy("name");
    setSortOrder("asc");
    setStartDate("");
    setEndDate("");
    setAllowPaginate(true);
    if (page === 1) {
      setListVersion((v) => v + 1);
    } else {
      setPage(1);
    }
  };

  const listCount = deleteItem ? deletedItems.length : items.length;

  return (
    <Container bg="#f8fafc">
      <Toaster
        position="top-right"
        toastOptions={{
          className: "text-sm font-medium shadow-lg",
          duration: 3500,
        }}
      />

      <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pb-16 space-y-6">
        {/* Üst başlık kartı */}
        <div className="rounded-2xl border border-slate-200/80 bg-white p-6 sm:p-8 shadow-sm shadow-slate-200/50">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white shadow-md shadow-indigo-500/25">
                <FaBox className="text-xl" aria-hidden />
              </div>
              <div className="min-w-0 space-y-1">
                <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
                  {!deleteItem ? "Ürünler" : "Silinen ürünler"}
                </h1>
                <p className="max-w-xl text-sm leading-relaxed text-slate-600">
                  {!deleteItem
                    ? "Barkod, filtre veya kamera ile hızlıca arayın; listeyi aşağı kaydırarak genişletin."
                    : "Çöp kutusundaki kayıtlar. Kalıcı silmeden önce emin olun."}
                </p>
                <div className="flex flex-wrap items-center gap-2 pt-2">
                  <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
                    {listCount} kayıt
                  </span>
                  {loading && !deleteItem && (
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-indigo-50 px-3 py-1 text-xs font-medium text-indigo-700">
                      <FaSpinner className="animate-spin" size={12} />
                      Yükleniyor
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end lg:flex-col lg:items-end xl:flex-row xl:items-center">
              <div className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50/80 px-4 py-2.5 sm:justify-start">
                <span className="text-sm font-medium text-slate-600">
                  Silinenleri göster
                </span>
                <Switch
                  checked={deleteItem}
                  onChange={setDeleteItem}
                  className={`${
                    deleteItem ? "bg-indigo-600" : "bg-slate-300"
                  } relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2`}
                >
                  <span
                    className={`${
                      deleteItem ? "translate-x-6" : "translate-x-1"
                    } inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-200 ease-out`}
                  />
                </Switch>
              </div>

              <div className="flex flex-wrap items-center justify-end gap-2">
                {deleteItem && (
                  <button
                    type="button"
                    onClick={deleteAll}
                    className="inline-flex items-center justify-center gap-2 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                  >
                    <FaTrash size={14} />
                    Hepsini sil
                  </button>
                )}
                <button
                  type="button"
                  onClick={linkHandel}
                  className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                  title="30 satır ekle"
                >
                  <FaBolt className="text-amber-500" size={14} />
                  30× hızlı
                </button>
                <Link
                  to="/dashboard/addProduct"
                  className="inline-flex items-center justify-center gap-2 rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-indigo-500/30 transition hover:bg-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                >
                  <FaPlus size={14} />
                  Ürün ekle
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Arama & aksiyonlar */}
        {!deleteItem && (
          <div className="rounded-2xl border border-slate-200/80 bg-white p-4 shadow-sm shadow-slate-200/50 sm:p-5">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-stretch">
              <div className="relative min-w-0 flex-1">
                <FaBarcode
                  className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400"
                  size={18}
                />
                <input
                  type="text"
                  value={barcode}
                  onChange={(e) => setBarcode(e.target.value)}
                  onKeyDown={keyHandel}
                  placeholder="Barkod yazın veya okutun — Enter ile ara"
                  autoComplete="off"
                  className={`${inputBase} pl-11 py-3 text-[15px]`}
                />
              </div>
              <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
                <button
                  type="button"
                  onClick={filterHandel}
                  className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-semibold text-emerald-800 transition hover:bg-emerald-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 lg:flex-initial lg:px-5"
                >
                  <FaFilter size={15} />
                  Filtreler
                </button>
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow-md shadow-indigo-500/25 transition hover:bg-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 lg:flex-initial lg:px-5"
                >
                  <FaCamera size={15} />
                  Kamera
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Filtre modal */}
        <div
          ref={filterContainer}
          className="fixed inset-0 z-50 hidden bg-slate-900/40 backdrop-blur-sm transition-opacity"
          role="dialog"
          aria-modal="true"
          aria-labelledby="filter-dialog-title"
        >
          <div
            className="flex min-h-full items-end justify-center p-4 sm:items-center"
            onClick={filterHandel}
          >
            <div
              className="max-h-screen  w-full max-w-lg overflow-hidden rounded-t-2xl border border-slate-200 bg-white shadow-2xl sm:rounded-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="max-h-[min(90vh,720px)] overflow-y-auto">
                <div className="sticky top-0 z-10 flex items-start justify-between gap-4 border-b border-slate-100 bg-white/95 px-6 py-5 backdrop-blur-sm">
                  <div>
                    <h2
                      id="filter-dialog-title"
                      className="text-lg font-bold tracking-tight text-slate-900"
                    >
                      Detaylı filtre
                    </h2>
                    <p className="mt-1 text-sm leading-relaxed text-slate-600">
                      Ad, kategori, stok, sıralama ve tarih aralığına göre daraltın.
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={filterHandel}
                    className="rounded-xl p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                    aria-label="Kapat"
                  >
                    <FaTimes size={20} />
                  </button>
                </div>

                <div className="space-y-5 px-6 py-6">
                  <div>
                    <label htmlFor="filter-name" className={labelBase}>
                      Ürün adı
                    </label>
                    <div className="relative">
                      <FaSearch
                        className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400"
                        size={16}
                      />
                      <input
                        id="filter-name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Örn. sütaç, çikolata…"
                        className={`${inputBase} pl-10`}
                      />
                    </div>
                  </div>

                  <div className="grid gap-5 sm:grid-cols-2">
                    <div className="sm:col-span-2">
                      <label htmlFor="filter-category" className={labelBase}>
                        Kategori
                      </label>
                      <select
                        id="filter-category"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        className={inputBase}
                      >
                        <option value="">Tüm kategoriler</option>
                        {categories.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label htmlFor="filter-stock" className={labelBase}>
                        Stok
                      </label>
                      <select
                        id="filter-stock"
                        value={stockStatus}
                        onChange={(e) => setStockStatus(e.target.value)}
                        className={inputBase}
                      >
                        <option value="all">Tümü</option>
                        <option value="in_stock">Stokta</option>
                        <option value="out_of_stock">Stokta yok</option>
                        <option value="low">Düşük stok</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="filter-sort" className={labelBase}>
                        Sırala
                      </label>
                      <select
                        id="filter-sort"
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        className={inputBase}
                      >
                        <option value="name">Ada göre</option>
                        <option value="price">Fiyata göre</option>
                        <option value="stock">Stok miktarına göre</option>
                        <option value="cost">Maliyete göre</option>
                        <option value="date">Tarihe göre</option>
                      </select>
                    </div>

                    <div className="sm:col-span-2">
                      <label htmlFor="filter-order" className={labelBase}>
                        Sıra yönü
                      </label>
                      <select
                        id="filter-order"
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        className={inputBase}
                      >
                        <option value="asc">Artan</option>
                        <option value="desc">Azalan</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                      <label htmlFor="filter-start" className={labelBase}>
                        Başlangıç
                      </label>
                      <input
                        id="filter-start"
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className={inputBase}
                      />
                    </div>
                    <div>
                      <label htmlFor="filter-end" className={labelBase}>
                        Bitiş
                      </label>
                      <input
                        id="filter-end"
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className={inputBase}
                      />
                    </div>
                  </div>

                  <div className="rounded-xl border border-slate-200 bg-slate-50/80 p-4">
                    <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
                      <span className={labelBase + " mb-0"}>Fiyat aralığı</span>
                      <span className="text-sm font-semibold tabular-nums text-indigo-600">
                        {minValue.toLocaleString("tr-TR")} ₺ —{" "}
                        {maxValue.toLocaleString("tr-TR")} ₺
                      </span>
                    </div>
                    <MultiRangeSlider
                      min={0}
                      max={SLIDER_MAX}
                      step={1000}
                      minValue={minValue}
                      maxValue={maxValue}
                      onInput={handleInput}
                      className="!border-none !shadow-none"
                      barInnerColor="#6366f1"
                      ruler={false}
                    />
                  </div>
                </div>

                <div className="sticky bottom-0 flex gap-3 border-t border-slate-100 bg-white/95 px-6 py-4 backdrop-blur-sm">
                  <button
                    type="button"
                    onClick={resetFilters}
                    className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2"
                  >
                    <FaTrash size={14} />
                    Sıfırla
                  </button>
                  <button
                    type="button"
                    onClick={filterByname}
                    className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-indigo-600 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-500/25 transition hover:bg-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                  >
                    <FaFilter size={14} />
                    Uygula
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Kamera modal */}
        {open && (
          <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/50 p-4 backdrop-blur-sm sm:items-center">
            <div className="w-full max-w-2xl overflow-hidden rounded-t-2xl border border-slate-200 bg-white shadow-2xl sm:rounded-2xl">
              <div className="border-b border-slate-100 px-5 py-4">
                <h3 className="text-base font-bold text-slate-900">
                  Barkod tara
                </h3>
                <p className="mt-0.5 text-sm text-slate-600">
                  Kodu kadraj içine alın; otomatik aranır.
                </p>
              </div>
              <div className="p-4 sm:p-5">
                <div className="overflow-hidden rounded-xl bg-black">
                  <BarcodeScanner options={options} onCapture={onCapture} />
                </div>
                <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center">
                  {isSupportTorch && (
                    <button
                      type="button"
                      onClick={onTorchSwitch}
                      className="inline-flex items-center justify-center gap-2 rounded-xl bg-amber-400 px-4 py-3 text-sm font-semibold text-amber-950 transition hover:bg-amber-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2"
                    >
                      El feneri
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className="inline-flex flex-1 items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2"
                  >
                    Kapat
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Ürün grid */}
        <section aria-label="Ürün listesi">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 xl:grid-cols-4">
            {(deleteItem ? deletedItems : items).map((item, index) => (
              <ProductCard key={index + item.barcode} item={item} />
            ))}
          </div>
          {listCount === 0 && !loading && (
            <div className="mt-10 rounded-2xl border border-dashed border-slate-200 bg-white px-6 py-14 text-center">
              <FaBox
                className="mx-auto mb-4 text-4xl text-slate-300"
                aria-hidden
              />
              <p className="text-base font-semibold text-slate-800">
                {deleteItem
                  ? "Silinen ürün yok"
                  : "Henüz gösterilecek ürün yok"}
              </p>
              <p className="mt-2 text-sm text-slate-600">
                {deleteItem
                  ? "Çöp kutusu boş."
                  : "Filtreleri sıfırlayın veya yeni ürün ekleyin."}
              </p>
            </div>
          )}
        </section>
        {!deleteItem && allowPaginate && (
          <span ref={lastCardElementRef} className="block h-4 w-full" aria-hidden />
        )}
      </div>
    </Container>
  );
};

export default Product;
